import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import { Content, ContentVariants } from '@patternfly/react-core';
export const PropertyItem = (_a) => {
    var { className = '', label, value = null } = _a, props = __rest(_a, ["className", "label", "value"]);
    const classes = css('properties-side-panel-pf-property', className);
    return (React.createElement("div", Object.assign({ className: classes }, props),
        React.createElement(Content, { component: ContentVariants.h5, className: "properties-side-panel-pf-property-label" }, label),
        React.createElement("div", { className: "properties-side-panel-pf-property-value" }, value)));
};
PropertyItem.displayName = 'PropertyItem';
//# sourceMappingURL=PropertyItem.js.map